import { Flex, Button } from "antd";

import StyledModal from "./style";

const ModalCompanyUserArchive = ({
  companyUserData,
  loading,
  onCancel,
  onConfirm,
  open,
}) => (
  <StyledModal
    closeIcon={false}
    footer={
      <Flex justify="space-between">
        <Button onClick={onCancel} shape="round">
          Cancel
        </Button>
        <Button
          disabled={loading}
          onClick={onConfirm}
          shape="round"
          type="primary"
        >
          Archive
        </Button>
      </Flex>
    }
    onCancel={onCancel}
    open={open}
    title="Confirm Archive"
    width={444}
  >
    <p>
      Are you sure you want to archive this user?
      <br />
      <b>
        {companyUserData?.firstName} {companyUserData?.lastName}
      </b>{" "}
      ({companyUserData?.email})
    </p>
  </StyledModal>
);

export default ModalCompanyUserArchive;
